__turbopack_context__.v({
  "nav": "NavTabs-module__xYrASq__nav",
  "navTabs": "NavTabs-module__xYrASq__navTabs",
  "navTabsLink": "NavTabs-module__xYrASq__navTabsLink",
});
